export default __webpack_public_path__ + "static/media/twitter_bg_lightgreen_color_white.9f7c43e5.svg";